import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import de from './locales/de.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ar from './locales/ar.json';
import zh from './locales/zh.json';
import it from './locales/it.json';

const LOCALE_STORAGE_KEY = 'shopping_locale';
const SUPPORTED_LOCALES = ['en', 'es', 'fr', 'pt', 'de', 'ja', 'ko', 'ar', 'zh', 'it'];

const savedLocale = localStorage.getItem(LOCALE_STORAGE_KEY);
const initialLocale = SUPPORTED_LOCALES.includes(savedLocale) ? savedLocale : 'en';

const applyDocumentLanguage = (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      pt: { translation: pt },
      de: { translation: de },
      ja: { translation: ja },
      ko: { translation: ko },
      ar: { translation: ar },
      zh: { translation: zh },
      it: { translation: it },
    },
    lng: initialLocale,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

applyDocumentLanguage(initialLocale);

i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LOCALE_STORAGE_KEY, lng);
  applyDocumentLanguage(lng);
});

export const changeLanguage = (lng) => i18n.changeLanguage(lng);
export const SUPPORTED_LANGUAGES = [
  { code: 'en', labelKey: 'header.english' },
  { code: 'es', labelKey: 'header.spanish' },
  { code: 'fr', labelKey: 'header.french' },
  { code: 'pt', labelKey: 'header.portuguese' },
  { code: 'de', labelKey: 'header.german' },
  { code: 'ja', labelKey: 'header.japanese' },
  { code: 'ko', labelKey: 'header.korean' },
  { code: 'ar', labelKey: 'header.arabic' },
  { code: 'zh', labelKey: 'header.chinese' },
  { code: 'it', labelKey: 'header.italian' },
];

export default i18n;
